module.exports = __webpack_public_path__ + "img/1.24dd664d.png";